module.exports = __webpack_public_path__ + "img/zk-icon-finance.a6c13f98.svg";